// contactApi.js
// Contact form service module for sending customer inquiries
// Sends form data to backend which handles email delivery
// Used by contact page and potentially other customer communication features

import apiRequest from './api';

// Sends contact form data to the server
// Parameters: data object containing name, email, subject, message, etc.
// Returns confirmation response from server
export async function sendContactForm(data) {
  return apiRequest('/Contact', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}